import { useCallback, useState } from 'react';

import { Step } from './types';

const headerTitleByStep: Record<Step, string> = {
  [Step.ADD_CARD_FORM]: 'Add Your Gift Card',
  [Step.CARD_SUMMARY]: 'Gift Card Summary',
  [Step.CHECK_BALANCE]: 'Gift Card Balance',
};

export function useGiftCardsActionSheet({
  isCheckBalanceFlow = false,
}: { isCheckBalanceFlow?: boolean } = {}) {
  const [actionSheetOpen, setActionSheetOpen] = useState(false);
  const [currentStep, setCurrentStep] = useState<Step>(Step.ADD_CARD_FORM);

  const handleActionSheetOpen = useCallback(() => {
    setActionSheetOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setActionSheetOpen(false);
    setCurrentStep(Step.ADD_CARD_FORM);
  }, []);

  const headerTitle =
    isCheckBalanceFlow && currentStep === Step.CHECK_BALANCE
      ? 'Gift Card Balance'
      : headerTitleByStep[currentStep];

  return {
    actionSheetOpen,
    handleActionSheetOpen,
    handleClose,
    currentStep,
    setCurrentStep,
    headerTitle,
  };
}
